import { useRef } from "react";

import { faCheck, faChevronDown } from "@fortawesome/pro-regular-svg-icons";
import { twJoin } from "tailwind-merge";
import { useBoolean, useOnClickOutside } from "usehooks-ts";

import { EnumOptionsBE } from "src/api/flowTypes";
import { ControllableDropdown } from "src/datasets/components/ControllableDropdown";
import { Icon, IconButton } from "src/design-system/Icon";

export const EnumPicker: React.FC<{
  options: EnumOptionsBE;
  onSelect: (value: string) => void;
  selectedValues?: string[];
}> = ({ options, onSelect, selectedValues }) => {
  const {
    value: isOpen,
    setTrue: setOpenTrue,
    setFalse: setOpenFalse,
  } = useBoolean();

  const dropdownRef = useRef<HTMLDivElement>(null);
  useOnClickOutside(dropdownRef, () => setOpenFalse());

  return (
    <div ref={dropdownRef} className="relative">
      <IconButton
        dataLoc="dataset-enum-dropdown"
        icon={faChevronDown}
        size="2xs"
        onClick={() => setOpenTrue()}
      />
      <div className="absolute top-7 right-40">
        <ControllableDropdown isOpen={isOpen}>
          {options.map(
            (option) =>
              option && (
                <div
                  className={twJoin(
                    "flex min-w-[160px] max-w-56 cursor-pointer items-center justify-between gap-x-2 truncate px-4 py-2.5 hover:bg-gray-50",
                  )}
                  onClick={() => {
                    onSelect(option.toString());
                    setOpenFalse();
                  }}
                >
                  {option}
                  {Array.isArray(selectedValues) &&
                    selectedValues.includes(option.toString()) && (
                      <Icon icon={faCheck} size="sm" variant="active" />
                    )}
                </div>
              ),
          )}
        </ControllableDropdown>
      </div>
    </div>
  );
};
